export default {
  computed: {
    isDesktop() {
      // @ts-ignore
      return this.$vuetify.breakpoint.mdAndUp
    }
  }
}
